export const MAX = 'Max';
export const MIN = 'Min';

// Allowed Units
export const UNIT_CENTIMETERS = 'cm';
export const UNIT_INCHES = 'in';

// Data set Keys
export const UNIT_CENTIMETERS_KEY = 'Cm';
export const UNIT_INCHES_KEY = 'In';

// Measurement unit query param
export const MEASUREMENT_UNIT_PARAM = 'measurement-unit';

// Regex patterns to display on strings of digits
export const DECIMAL_DIGITS_ONLY_PATTERN = /^[1-9]\d*(\.\d+)?$/;



// WEBPACK FOOTER //
// ./assets/js/finding/components/Dimensions/constants.es.js